<!-- Footer -->
<footer class="page-footer font-small black">
  <!-- Copyright -->
  <div class="footer-copyright text-center py-3">
    <a
      href="https://www.facebook.com/Diyasty"
      type="button"
      class="light-blue-text mx-2"
    >
      <i style="font-size: 33px;" class="fab fa-facebook"></i>
    </a>
    <a
      href="https://www.linkedin.com/in/diyasty/"
      type="button"
      class="light-blue-text mx-2"
    >
      <i style="font-size: 33px;" class="fab fa-linkedin"></i>
    </a>
    <a
      href="https://github.com/Diyasty"
      type="button"
      class="light-blue-text mx-2"
    >
      <i style="font-size: 33px;" class="fab fa-github"></i>
    </a>

    <h4 class="text-white mt-2 ">
      © Made With <i style="color: red;" class="fas fa-heart"></i> Mohamed
      Eldiyasty
    </h4>
  </div>
  <!-- Copyright -->
</footer>
<!-- Footer -->
